/*
 * @LastEditors: whb
 * @LastEditTime: 2023-04-19 14:13:42
 * @Description: 
 * @FilePath: /starmaker-starvr-officialnew/src/pages/home/components/introduce/static.js
 */
export const intro1 = [
  "Are you ready to rock out?",
  `Let's build a band in Party room!`,
  `Invite friends to join your virtual party, collaborate on music projects, and even host live performances! Don't forget to use instruments to make your music more creative! `,
  `Connect with people from all around the world who share your passion for music, interact with others, share your music creations, and make new friends all in a virtual reality environment.`
]

export const intro2 = [
  `Are you ready to take your singing skills to the next level? Or prefer to sing solo? SingStar offers access to over 2 million songs in the library!`,
  "Find every kind of songs you like, ranging from classic hits to modern pop tracks, it offers something for everyone.",
  `Whether you're a professional singer or just someone who loves to sing in the shower, SingStar in StarMaker is the perfect platform to showcase your talent.`,
  `Are you ready to take center stage?`
]

export const intro3 = [
  "Immerse yourself in a virtual world of music, dancing and socializing.",
  "With stunning visuals and a wide variety of environments to choose from, it is the perfect place to relax, let your hair down and enjoy your favorite tunes.",
  "Sing your heart out to your favorite songs and compete with other singers for high scores on the leaderboard.",
  "Whether you want to sing your heart out in a beautiful nature setting, dance the night away in a neon cityscape, or escape to a magical fantasy world, the options are limitless!"
]

export const intro4 = [
  "Channel your inner samurai and become a Taiko master!",
  "With your drumsticks in hand, you can beat out the rhythm of the music and feel like a real Taiko master.",
  "And with its engaging gameplay and charming visuals, TaikoStar is a delight for the senses.",
  "With a constantly expanding library of songs and drumming patterns, you'll never run out of new challenges to conquer in TaikoStar, there's something for everyone in this exciting and unique game."
]

export const intro5 = [
  "Ready for a challenge?",
  `Let's experience a unique and thrilling experience that combines the fast-paced action of a shooter game.`,
  `As you battle digital demons and protect the music world, you'll need to be quick on your feet and even quicker with your hands.`,
  `With intuitive controls and engaging gameplay, you'll be blasting away at the enemy in no time.`
]